import React from 'react'
import { ComprehensiveAssessmentManagementStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  Paginate,
  Section,
  Tabber,
  Table,
  Input,
  Spinner,
  Text,
  Breadcrumbs,
  SelectBox,
} from '../../components'
import { ICONS } from '../../themes'
import { isEmpty, isError } from 'lodash'
import {
  ROUTE_PATH,
  STRING,
  toastFail,
  toastActive,
  dateMonDayYearTime,
  yup as Yup,
} from '../../helpers'
import { connect } from 'react-redux'
import { comprehensiveController } from '../../apiService'
import { Formik, Form, FieldArray, Field } from 'formik'
import NumberFormat from 'react-number-format'
import { pageComprehensiveController, rolesObj } from '../../middleware'
import { Link } from 'react-router-dom'
import Numeral from 'numeral'
import ReactTooltip from 'react-tooltip'
export class ComprehensiveAssessmentManagement extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)

    this.state = {
      topicValid: true,
      topicValidText: STRING.INVALID,
      templateValid: true,
      // templateValidText: STRING.INVALID,
      templateValidText: '',
      modals: [
        { name: 'templateManager', isOpen: false },
        { name: 'editScore', isOpen: false },
        { name: 'delete', isOpen: false, fullName: '', idList: '' },
        { name: 'send', isOpen: false },
        { name: 'deleteOnline', isOpen: false, fullName: '', idList: '' },
      ],
      indexTab: 0,
      offlines: [],
      resOffline: {
        limit: null,
        next_page: null,
        offset: null,
        page: null,
        prev_page: null,
        records: [],
        total_page: null,
        total_record: 0,
      },
      formDetail: {
        name: '',
        id: null,
        topic_offline_template: [],
        topicName: '',
      },
      formOffline: {
        name: '',
        topic_offline_template: [],
        topicName: '',
      },
      grade: '',
      gradeValidate: [],
      gradeTypeList: [],
      gradeTypeOption: [],
      gradeTypeSelect: [],
      searchPage: 1,
      activePage: 1,
      isLoading: false,
      isCategoryLoading: false,
      offlineID: null,
      checkRole: '',
      listOnline: [],
      resOnline: {
        limit: null,
        next_page: null,
        offset: null,
        page: null,
        prev_page: null,
        records: [],
        total_page: null,
        total_record: null,
      },
      searchPageOnline: 1,
      activePageOnline: 1,
    }
    this.listDelete = ''
    this.listSent = ''
    this.listOnlineDelete = ''
    this.renderEmptyResult = this.renderEmptyResult.bind(this)
  }

  toggleModal = (evt, id, name) => {
    return this.setState({
      modals: this.state.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === evt ? !modal.isOpen : false,
        idList: id,
        fullName: name,
        topicName: '',
      })),
    })
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (nextProps && nextProps.user && this._isMounted) {
  //     const { user } = nextProps
  //     const userID = this.props.user ? this.props.user.id : null
  //     if (user.id !== userID) {
  //       this.runGetOffline(user)
  //     }
  //   }
  // }

  componentDidMount() {
    this._isMounted = true
    const { user } = this.props
    this.runGetOffline(user)
    const roles = pageComprehensiveController().asset()
    this.setState({ checkRole: roles })
    this.getGradeType()
    this.getOnline()

    if (
      this.props.location.state &&
      this.props.location.state.from === 'online'
    ) {
      this.setState({ indexTab: 1 })
    }
  }

  componentWillUnmount() {
    this.clearValid()
    this._isMounted = false
    this.mount = false
  }

  runGetOffline = user => {
    if (user) {
      if (this._isMounted) {
        this.setState({ offlineID: user.id })
      }
      return this.getOffline(user.id)
    }
  }

  getOffline = async () => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      const params = {
        page: this.state.activePage,
      }
      const res = await comprehensiveController().getOffline(params)
      // console.log('getOffline', res)
      if (res) {
        this.initState(res)
        if (this._isMounted) {
          this.setState({ isLoading: false })
        }
      }
    } catch (error) {
      throw error
    }
  }

  getOfflineByID = async id => {
    try {
      if (!id) return
      if (this._isMounted) {
        this.setState({ isCategoryLoading: true })
      }
      const res = await comprehensiveController().getOfflineID(id)
      if (res) {
        if (this._isMounted) {
          this.setState({
            offlineByID: res,
            isCategoryLoading: false,
            formDetail: {
              topicName: '',
              id,
              name: res.name,
              topic_offline_template: res.topic_offline_template.map(
                nameTopic => {
                  return { name: nameTopic.name }
                }
              ),
            },
            grade:
              res.offline_template_grade.length > 0
                ? res.offline_template_grade
                : '',
          })
          if (res.offline_template_grade.length > 0) {
            const { gradeTypeOption } = this.state
            let selectGrade = ''
            gradeTypeOption.map(item => {
              if (item.value === res.offline_template_grade[0].grade_type_id) {
                this.setState({ gradeTypeSelect: item })
              }
            })
          }
        }
      }
    } catch (error) {
      throw error
    }
  }

  getOnline = async () => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      const params = {
        page: this.state.activePageOnline,
      }
      const res = await comprehensiveController().getOnline(params)
      // console.log('getOnline', res)
      if (res) {
        this.setState({ listOnline: res.records, resOnline: res })
        if (this._isMounted) {
          this.setState({ isLoading: false })
        }
      }
    } catch (error) {
      throw error
    }
  }

  getGradeType = async () => {
    try {
      const res = await comprehensiveController().getGradeType()
      if (res) {
        let option = []
        res.map((item, index) => {
          option.push({
            value: item.offline_template_grade_type.id,
            label: item.offline_template_grade_type.name,
          })
        })
        this.setState({
          isLoading: false,
          gradeTypeList: res,
          gradeTypeOption: option,
        })
      }
    } catch (error) {
      throw error
    }
  }

  submitCreateOfflineTemplates = async (values, formiksActions) => {
    if (!values) return
    if (!this.state.topicValid) return
    let validateGrade = this.validateGradeValue()
    if (validateGrade) {
      if (values.topic_offline_template < 1) {
        if (this._isMounted) {
          this.setState({
            topicValid: false,
            topicValidText: STRING.INVALID,
          })
        }
      } else if (values.name.trim() === '') {
        if (this._isMounted) {
          this.setState({
            templateValid: false,
            templateValidText: STRING.INVALID,
          })
        }
      } else {
        this.createOfflineTemplates(values, formiksActions)
        this.closeModal()
      }
    } else {
      toastFail('Please enter a valid grade value.')
    }
  }

  validateGradeValue() {
    const { grade } = this.state
    // console.log(grade)
    const grades = grade || []
    let isDone = true
    let gradeValidate = []
    for (var i = 0; i < grades.length; i++) {
      let validate = {
        value_from: false,
        value_to: false,
      }
      if (
        parseFloat(grades[i].value_from).toString() !== 'NaN' &&
        parseFloat(grades[i].value_to).toString() !== 'NaN'
      ) {
        if (grades[i].value_from >= grades[i].value_to) {
          isDone = false
          validate.value_from = true
          validate.value_to = true
        }
        if (i > 0 && grades[i].value_to >= grades[i - 1].value_from) {
          isDone = false
          validate.value_to = true
        }
      } else {
        isDone = false
        validate.value_from = true
        validate.value_to = true
      }
      gradeValidate.push(validate)
    }
    this.setState({ gradeValidate })
    return isDone
  }

  submitUpdateOfflineTemplates = (values, formiksActions) => {
    if (!values) return
    if (!this.state.topicValid) return
    let validateGrade = this.validateGradeValue()
    if (validateGrade) {
      if (values.topic_offline_template < 1) {
        if (this._isMounted) {
          this.setState({
            topicValid: false,
            topicValidText: STRING.INVALID,
          })
        }
      } else if (values.name.trim() === '') {
        if (this._isMounted) {
          this.setState({
            templateValid: false,
            templateValidText: STRING.INVALID,
          })
        }
      } else {
        this.updateOffline(values, formiksActions)
      }
    } else {
      toastFail('Please enter a valid grade value.')
    }
  }

  checkTopicNameDuplocate = values => {
    if (values) {
      const topicNameList = values.topic_offline_template || []
      const topic = values.topicName
      if (topic) {
        const duplicateTopicName = topicNameList.find(e => {
          if (typeof topic === 'string' && typeof e.name === 'string') {
            return topic.toLowerCase() === e.name.toLowerCase()
          }
        })
        return duplicateTopicName
      }
    }
  }

  createOfflineTemplates = async (
    values = {
      name: '',
      topicOfflineTemplate: [],
    },
    formilActions = () => {}
  ) => {
    try {
      values.name = values.name.trim()
      if (this.state.grade !== '') {
        values.offline_template_grade = this.state.grade
      }
      const res = await comprehensiveController().createOffline(values)
      if (res) {
        if (res.status === 'InSertSuccess') {
          if (this._isMounted) {
            this.setState({
              templateValid: true,
            })
          }
          toastActive('Insert Data Complete')
          this.closeModal()
          this.resetForm(formilActions)
        } else if (res.status === 'Duplicate') {
          if (this._isMounted) {
            this.setState({
              templateValid: false,
              templateValidText: 'Template name duplicate',
            })
          }
          this.toggleModal('templateManager')
          this.closeModal()
        }
        this.toggleModal('templateManager')
        this.getOffline()
        this.closeModal()
      } else {
        toastFail('Please check input value')
      }
    } catch (error) {
      throw ('update fail', error)
    }
  }

  handleUserInput = e => {
    const { name, value } = e.target
    if (this._isMounted) {
      return this.setState({ [name]: value }, () => {})
    }
  }

  initState = offlines => {
    if (this._isMounted) {
      return this.setState({ offlines: offlines.records, resOffline: offlines })
    }
  }

  onPageChange = pageNumber => {
    const { offlineID } = this.state
    if (this._isMounted) {
      return this.setState({ activePage: pageNumber }, () => {
        this.getOffline(offlineID)
      })
    }
  }

  onPageChangeOnline = pageNumber => {
    if (this._isMounted) {
      return this.setState({ activePageOnline: pageNumber }, () => {
        this.getOnline()
      })
    }
  }

  onClickEdit = async (id, name, topic_offline_template = []) => {
    if (this._isMounted) {
      this.setState({
        grade: [],
        formDetail: {
          id,
          name,
          topicOfflineTemplate: topic_offline_template,
        },
      })
      this.getOfflineByID(id)
      this.toggleModal('editScore')
    }
    // document.body.classList.add('modal-open')
  }

  onClose = (formikSetFieldValue = () => {}) => {
    this.toggleModal('templateManager')
    this.closeModal()
    setTimeout(() => {
      formikSetFieldValue('topic_offline_template', [])
      formikSetFieldValue('name', '')
    }, 500)
    if (this._isMounted) {
      this.setState({
        topicValid: true,
        templateValid: true,
      })
    }
  }

  onClickClose = () => {
    this.toggleModal()
    document.body.classList.remove('modal-open')
    this.clearValid()
  }

  onClickCreate = () => {
    this.setState({
      grade: '',
      formOffline: {
        name: '',
        topic_offline_template: [],
        topicName: '',
      },
    })
    this.toggleModal('templateManager')
    document.body.classList.add('modal-open')
  }

  updateOffline = async (
    values = {
      id: null,
      name: '',
      topicOfflineTemplate: [{ nameTopic: '' }],
    },
    formiksActions = () => {}
  ) => {
    try {
      values.name = values.name.trim()
      if (this.state.grade !== '') {
        values.offline_template_grade = this.state.grade
      }
      const res = await comprehensiveController().updateOffline(values)
      if (res) {
        if (res.status === 'UpdateSuccess') {
          toastActive('Update was successes')
          this.clearValid()
          this.closeModal()
          this.resetForm(formiksActions)
        } else if (res.status === 'Duplicate') {
          if (this._isMounted) {
            this.setState({
              templateValid: false,
              templateValidText: 'Template name duplicate',
            })
          }
          this.toggleModal('editScore')
          this.closeModal()
        }
        this.toggleModal('editScore')
        this.getOffline()
        this.closeModal()
      } else {
        toastFail('Update was Fail')
      }
    } catch (error) {
      throw ('update fail', error)
    }
  }

  async _fetchdeleteOffline(id) {
    const res = await comprehensiveController().deleteOffline(id)
    if (res) {
      await this.getOffline()
    } else {
      if (this._isMounted) {
        return this.setState({ BuyerListLoading: false })
      }
    }
  }

  async _fetchdeleteOnline(id) {
    const res = await comprehensiveController().deleteOnline(id)
    // console.log('_fetchdeleteOnline',res)
    if (res) {
      await this.getOnline()
    } else {
      if (this._isMounted) {
        return this.setState({ BuyerListLoading: false })
      }
    }
  }

  addTopicName = (arrayDataHelpers, values, setFieldValue) => {
    if (!values) return
    if (this.checkTopicNameDuplocate(values)) {
      if (this._isMounted) {
        this.setState({
          topicValid: false,
          topicValidText: 'Topic name duplicate',
        })
      }
    } else {
      if (
        values.topicName === '' ||
        values.topicName === undefined ||
        values.topicName.trim() === ''
      ) {
        if (this._isMounted) {
          this.setState({
            topicValid: false,
            topicValidText: STRING.INVALID,
          })
        }
      } else {
        if (this._isMounted) {
          this.setState({
            topicValid: true,
          })
        }
        arrayDataHelpers.push({
          name: values.topicName.trim(),
        })
        setFieldValue('topicName', '')
      }
    }
  }

  deleteList = () => {
    this._fetchdeleteOffline(this.listDelete)
    toastActive('Template was Deleted')
    this.toggleModal('delete')
    this.closeModal()
  }

  deleteOnlineList = () => {
    this._fetchdeleteOnline(this.listOnlineDelete)
    toastActive('Template was Deleted')
    this.toggleModal('deleteOnline')
    this.closeModal()
  }

  setInputArray = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`topic_offline_template[${index}].name`, target.value)
  }

  setInputToppicName = (formikSetvalue, event) => {
    formikSetvalue('topicName', event.target.value)
    this.clearTopicNameValid()
  }

  strToLowerCase = (str = '') => {
    return str.toLowerCase()
  }

  validateSchema = () => {
    const schema = Yup.object().shape({
      name: Yup.string().required(STRING.INVALID).trim(),
      topic_offline_template: Yup.array().of(
        Yup.object()
          .shape({
            name: Yup.string()
              .required(STRING.INVALID)
              .trim()
              .transform(name => this.strToLowerCase(name)),
          })
          .uniqueProperty('name', 'Topic name duplicate')
      ),
    })
    return schema
  }

  clearValid = () => {
    if (this._isMounted) {
      return this.setState({
        templateValid: true,
        topicValid: true,
        topicValidText: '',
        templateValidText: '',
      })
    }
  }

  clearTopicNameValid = () => {
    if (this._isMounted) {
      return this.setState({ topicValid: true, topicValidText: '' })
    }
  }

  closeModal = () => {
    document.body.classList.remove('modal-open')
  }

  resetForm = formilActions => {
    setTimeout(() => {
      formilActions.resetForm()
    }, 1000)
  }

  renderEmptyResult = listOffline => {
    if (isEmpty(listOffline))
      return (
        <Table.TBODY>
          <Table.TR>
            <Table.TD>
              <Section className="no-result-found">
                <Image src={ICONS['icon-ssr.png']} className="no-result" />
                <p>No result found</p>
              </Section>
            </Table.TD>
          </Table.TR>
        </Table.TBODY>
      )
  }

  renderGrade() {
    if (this.state.grade !== '') {
      return (
        <Section mt={'1rem'} className="grade-wrapper flex-column">
          <Section pb={'1rem'} mb={'1rem'} className="grade-header form-row">
            <Section className="width-auto">
              <Section ml={'1rem'} className="label width-auto">
                <label className="grade">Grade</label>
              </Section>
              <SelectBox
                onChange={e => {
                  if (!e.value) {
                    return null
                  }
                  let grades = []
                  let { gradeTypeSelect, gradeTypeList, grade } = this.state
                  // console.log(gradeTypeList, gradeTypeSelect, grade)
                  gradeTypeList.forEach(item => {
                    if (item.offline_template_grade_type.id === e.value) {
                      for (let i in item.offline_template_grade) {
                        let newObj = {
                          ...item.offline_template_grade,
                          grade_type_id:
                            item.offline_template_grade[i].grade_type_id,
                          name: item.offline_template_grade[i].name,
                          // value_from: '',
                          // value_to: '',
                        }

                        grades.push(newObj)
                      }
                      // grades = item.offline_template_grade
                    }
                  })

                  this.setState({
                    gradeTypeSelect: e,
                    grade: grades,
                  })
                }}
                id=""
                className=""
                value={this.state.gradeTypeSelect}
                options={this.state.gradeTypeOption}
                isSearchable={false}
                isClearable={false}
              />
            </Section>
            <Button
              className="theme-border-red btn-height-32 btn-cancel-grade"
              onClick={() =>
                this.setState({
                  grade: '',
                  gradeTypeSelect: [],
                })
              }
            >
              Cancel grade
            </Button>
          </Section>
          {this.state.grade.map((item, index) => {
            const { grade } = this.state
            const isValueFromError = this.checlValidateGrade(index, 'from')
            const isValueToError = this.checlValidateGrade(index, 'to')
            return (
              <Section className="grade-body" mb="10px" key={'grade' + index}>
                <Section className="grade-row">
                  <div className="grade-name-wrap">
                    <label className="grade-name">{item.name} : </label>
                  </div>
                  <Section className="form-group-grade">
                    <Section className="form-group-wrapper">
                      <Section
                        className={
                          isValueFromError
                            ? 'form-group-control is-error'
                            : 'form-group-control'
                        }
                      >
                        <Section className="form-group-inner-wrapper">
                          <NumberFormat
                            value={
                              item.value_from !== ''
                                ? Numeral(item.value_from).format('0,0.00')
                                : ''
                            }
                            placeholder="MIN"
                            customInput={Input}
                            decimalScale={2}
                            thousandSeparator={true}
                            onValueChange={e => {
                              if (e.floatValue > -1) {
                                item.value_from = parseFloat(
                                  Numeral(e.floatValue).format('0,0.00')
                                )
                                this.setState({ grade })
                              }
                            }}
                          />
                        </Section>
                      </Section>
                      <label className="separator"> - </label>
                      <Section
                        className={
                          isValueToError
                            ? 'form-group-control is-error'
                            : 'form-group-control'
                        }
                      >
                        <Section className="form-group-inner-wrapper">
                          <NumberFormat
                            value={
                              item.value_to !== ''
                                ? Numeral(item.value_to).format('0,0.00')
                                : ''
                            }
                            placeholder="MAX"
                            customInput={Input}
                            decimalScale={2}
                            thousandSeparator={true}
                            onValueChange={e => {
                              if (e.floatValue > -1) {
                                item.value_to = parseFloat(
                                  Numeral(e.floatValue).format('0,0.00')
                                )
                                this.setState({ grade })
                              }
                            }}
                          />
                        </Section>
                      </Section>
                    </Section>
                    <Section className="message">error</Section>
                  </Section>
                </Section>
              </Section>
            )
          })}
        </Section>
      )
    } else {
      return (
        <Button
          className="theme-dashed-blue"
          onClick={() => {
            let grade = []
            let gradeTypeSelect = this.state.gradeTypeOption.at(0)
            this.state.gradeTypeList.find(item => {
              if (
                item.offline_template_grade_type.id === gradeTypeSelect.value
              ) {
                for (var i = 0; i < item.offline_template_grade.length; i++) {
                  let newObj = {
                    grade_type_id: item.offline_template_grade[i].grade_type_id,
                    name: item.offline_template_grade[i].name,
                    value_from: '',
                    value_to: '',
                  }
                  grade.push(newObj)
                }
              }
            })
            this.setState({ grade, gradeTypeSelect })
          }}
        >
          Add Grade
        </Button>
      )
    }
  }

  checlValidateGrade(index, type) {
    const { gradeValidate } = this.state
    let isErrors = false
    if (gradeValidate.length > 0 && gradeValidate[index]) {
      if (type === 'from' && gradeValidate[index].value_from) {
        isErrors = true
      }
      if (type === 'to' && gradeValidate[index].value_to) {
        isErrors = true
      }
    }
    return isErrors
  }

  rederBusinessTypeText(data) {
    return data.map((item, i) => {
      return (
        <p key={i}>
          {i + 1} {this.rederBusinessType(item.online_business_type)}
        </p>
      )
    })
  }

  rederBusinessType(data, i) {
    let businessType = ''
    data.map((btg, btgIndex) => {
      if (btgIndex === data.length - 1) {
        businessType = businessType + btg.business_type
      } else {
        businessType = businessType + btg.business_type + ','
      }
    })
    if (businessType === '') {
      businessType = '-'
    }
    return businessType
  }

  render() {
    const {
      modals,
      resOffline,
      offlines,
      activePage,
      listOnline,
      resOnline,
    } = this.state
    const listOffline = resOffline.records
    return (
      <React.Fragment>
        <ComprehensiveAssessmentManagementStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  src={ICONS['icon-comprehensive- assessment.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section className="title">
                  {STRING.COMPREHENSIVE_ASSESSMENT_MANAGEMENT}
                </Section>
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Tabber
                className="comprehensive-assessment-management"
                selectedIndex={this.state.indexTab}
                onSelect={index => {
                  if (this._isMounted) {
                    return this.setState({
                      indexTab: index,
                    })
                  }
                }}
              >
                {/* TABS HEADER
                  -------------------------------------
                  -------------------------------------
                  */}
                <Tabber.TabList>
                  <Tabber.Tab>{STRING.OFFLINE_TEMPLATE_MANAGEMENT}</Tabber.Tab>

                  <Tabber.Tab>{STRING.ONLINE_TEMPLATE_MANAGEMENT}</Tabber.Tab>
                </Tabber.TabList>

                {/* Tabber Panels -Offline-
                  -------------------------------------
                  -------------------------------------
                  */}
                <Tabber.TabPanel>
                  <Section className="page-button">
                    {this.state.checkRole && (
                      <Button
                        className="page-button"
                        onClick={() => this.onClickCreate()}
                      >
                        Create New Template
                      </Button>
                    )}
                  </Section>

                  <Section mt="1rem" className="table-responsive">
                    <Table className="table-default">
                      {/* Header Row */}
                      <Table.THEAD>
                        <Table.TR>
                          <Table.TH id="template_name_header">
                            TEMPLATE NAME
                          </Table.TH>

                          <Table.TH
                            className="text-center"
                            id="last_update_header"
                          >
                            LAST UPDATE
                          </Table.TH>

                          <Table.TH
                            className="text-center"
                            id="created_by_header"
                          >
                            UPDATED BY
                          </Table.TH>

                          <Table.TH
                            className="actions w-150"
                            id="actions_header"
                          >
                            ACTIONS
                          </Table.TH>
                        </Table.TR>
                      </Table.THEAD>

                      {/* Content Row */}
                      <Table.TBODY>
                        {this.state.isLoading ? (
                          <Table.TR>
                            <Table.TD>
                              <Spinner />
                            </Table.TD>
                          </Table.TR>
                        ) : (
                          <React.Fragment>
                            {listOffline !== undefined &&
                              listOffline.map(item => (
                                <Table.TR key={item.id}>
                                  <Table.TD>
                                    <Text
                                      tootipValue={item.name}
                                      useTootip={true}
                                    >
                                      {item.name}
                                    </Text>
                                  </Table.TD>

                                  <Table.TD className="text-center">
                                    {dateMonDayYearTime(item.updated_at)}
                                    {/* {item.updated_at} */}
                                  </Table.TD>

                                  <Table.TD className="text-center">
                                    {item.updated_by_name}
                                  </Table.TD>

                                  <Table.TD className="actions w-150">
                                    <Section>
                                      {this.state.checkRole && (
                                        <>
                                          <Button
                                            className="link"
                                            onClick={() =>
                                              this.onClickEdit(
                                                item.id,
                                                item.name,
                                                item.topic_offline_template
                                              )
                                            }
                                          >
                                            <Image
                                              className="edit-icon"
                                              src={ICONS['icon-edit.svg']}
                                              alt="Edit"
                                              tootipValue={`Edit`}
                                              useTootipFor="Edit"
                                              useTootip={true}
                                            />
                                          </Button>
                                          {item.can_delete && (
                                            <Button
                                              className="link"
                                              onClick={() => {
                                                this.toggleModal(
                                                  'delete',
                                                  item.id,
                                                  item.name
                                                ),
                                                  (this.listDelete = item.id)
                                                document.body.classList.add(
                                                  'modal-open'
                                                )
                                              }}
                                            >
                                              <Image
                                                className="delete-icon"
                                                src={ICONS['icon-trash.svg']}
                                                alt="Delete"
                                                tootipValue={`Delete`}
                                                useTootipFor="Delete"
                                                useTootip={true}
                                              />
                                            </Button>
                                          )}
                                        </>
                                      )}
                                    </Section>
                                  </Table.TD>
                                </Table.TR>
                              ))}
                          </React.Fragment>
                        )}
                      </Table.TBODY>
                      {this.renderEmptyResult(listOffline)}
                    </Table>
                  </Section>
                  <Section className="content-footer">
                    <Section className="showing-item">
                      Showing{' '}
                      {offlines.length === 0
                        ? '0'
                        : Math.min(
                            (resOffline.page - 1) * resOffline.limit + 1
                          )}{' '}
                      to{' '}
                      {Math.min(
                        resOffline.total_record,
                        resOffline.limit * resOffline.page
                      )}{' '}
                      of {resOffline.total_record} entries
                    </Section>

                    <Section className="paginate-wrapper">
                      <Paginate
                        activePage={activePage}
                        onChange={pageNumber => this.onPageChange(pageNumber)}
                        itemsCountPerPage={resOffline.limit}
                        totalItemsCount={resOffline.total_record}
                        // pageRangeDisplayed={resOffline.total_page}
                      />

                      <Section className="moveto-wrapper">
                        <NumberFormat
                          label="Page"
                          isHorizontal
                          className="paginate-moveto"
                          defaultValue="1"
                          maxLength="4"
                          customInput={Input}
                          decimalSeparator={false}
                          allowNegative={false}
                          allowLeadingZeros={false}
                          onChange={e => {
                            if (this._isMounted) {
                              return this.setState({
                                searchPage: parseInt(e.target.value),
                              })
                            }
                          }}
                          isAllowed={values => {
                            const { value, floatValue } = values
                            if (value == 0 && value !== '') {
                              return false
                            }
                            if (
                              typeof floatValue === 'undefined' ||
                              typeof value === 'undefined'
                            ) {
                              return true
                            }
                            if (value.charAt(0) === '0') {
                              if (value.charAt(1) && value.charAt(1) != '.') {
                                return false
                              }
                            }
                            if (this.props.maximum) {
                              return floatValue <= this.props.maximum
                            } else {
                              return true
                            }
                          }}
                        />
                        <Button
                          disabled={
                            parseInt(this.state.searchPage) <=
                            parseInt(resOffline.total_page)
                              ? false
                              : true
                          }
                          onClick={() =>
                            this.onPageChange(this.state.searchPage)
                          }
                        >
                          go
                        </Button>
                      </Section>
                    </Section>
                  </Section>
                </Tabber.TabPanel>

                {/* Tabber Panels -Online-
                  -------------------------------------
                  -------------------------------------
                  */}
                <Tabber.TabPanel>
                  <Section className="page-button">
                    {this.state.checkRole && (
                      <Button
                        className="page-button"
                        onClick={() =>
                          this.props.history.push(
                            ROUTE_PATH.ONLINE_TEMPLATE_MANEGEMENT.LINK
                          )
                        }
                      >
                        Create New Template
                      </Button>
                    )}
                  </Section>
                  <Section mt="1rem" className="table-responsive">
                    <Table className="table-template table-default">
                      {/* Header Row */}
                      <Table.THEAD>
                        <Table.TR>
                          <Table.TH id="template_name_header">
                            TEMPLATE NAME
                          </Table.TH>

                          <Table.TH
                            id="last_update_header"
                            className="text-center"
                          >
                            LAST UPDATE
                          </Table.TH>

                          <Table.TH
                            id="update_by_header"
                            className="text-center"
                          >
                            UPDATE BY
                          </Table.TH>

                          <Table.TH id="business_type_header">
                            BUSINESS TYPE
                          </Table.TH>

                          <Table.TH
                            className="actions w-150"
                            id="actions_header"
                          >
                            ACTIONS
                          </Table.TH>
                        </Table.TR>
                      </Table.THEAD>

                      {/* Content Row */}
                      <Table.TBODY>
                        {listOnline !== undefined &&
                          listOnline.map((e, i) => (
                            <Table.TR key={i}>
                              <Table.TD>
                                <Text
                                  tootipValue={e.name}
                                  useTootipFor="name"
                                  useTootip={true}
                                >
                                  {e.name}
                                </Text>
                              </Table.TD>

                              <Table.TD className="text-center">
                                {dateMonDayYearTime(e.updated_at)}
                              </Table.TD>

                              <Table.TD className="text-center">
                                {e.updated_by_string}
                              </Table.TD>
                              <Table.TD>
                                {e.online_business_type_group &&
                                  e.online_business_type_group.map(
                                    (item, t) => {
                                      return (
                                        <React.Fragment key={t}>
                                          <div
                                            data-for={i + 'name'}
                                            data-tip
                                            className="business-type"
                                          >
                                            <div
                                              style={{
                                                minWidth:
                                                  e.online_business_type_group
                                                    .length > 9
                                                    ? '25px'
                                                    : '15px',
                                              }}
                                            >
                                              {t + 1}.
                                            </div>
                                            <Text useEllipsis={true}>
                                              {this.rederBusinessType(
                                                item.online_business_type
                                              )}
                                            </Text>
                                          </div>
                                          <ReactTooltip
                                            id={i + 'name'}
                                            place="bottom"
                                            effect="solid"
                                            className="background-white"
                                          >
                                            {e.online_business_type_group &&
                                              e.online_business_type_group.map(
                                                (item, t) => {
                                                  return (
                                                    <div
                                                      key={t}
                                                      className="business-type"
                                                    >
                                                      <div
                                                        style={{
                                                          minWidth:
                                                            e
                                                              .online_business_type_group
                                                              .length > 9
                                                              ? '25px'
                                                              : '15px',
                                                        }}
                                                      >
                                                        {t + 1}.
                                                      </div>
                                                      {this.rederBusinessType(
                                                        item.online_business_type
                                                      )}
                                                    </div>
                                                  )
                                                }
                                              )}
                                          </ReactTooltip>
                                        </React.Fragment>
                                      )
                                    }
                                  )}
                              </Table.TD>

                              <Table.TD className="actions w-150">
                                <Section>
                                  <Button
                                    // disabled={true}
                                    className="link"
                                    onClick={() => {
                                      this.props.history.push(
                                        ROUTE_PATH.ONLINE_TEMPLATE_MANEGEMENT
                                          .LINK,
                                        { id: e.id }
                                      )
                                    }}
                                  >
                                    <Image
                                      className="edit-icon"
                                      src={ICONS['icon-edit.svg']}
                                      alt="edit"
                                    />
                                  </Button>

                                  {e.can_delete && (
                                    <Button
                                      className="link"
                                      onClick={() => {
                                        this.toggleModal(
                                          'deleteOnline',
                                          e.id,
                                          e.name
                                        ),
                                          (this.listOnlineDelete = e.id)
                                        document.body.classList.add(
                                          'modal-open'
                                        )
                                      }}
                                    >
                                      <Image
                                        className="delete-icon"
                                        src={ICONS['icon-trash.svg']}
                                        alt="delete"
                                      />
                                    </Button>
                                  )}
                                </Section>
                              </Table.TD>
                            </Table.TR>
                          ))}
                      </Table.TBODY>
                      {isEmpty(listOnline) && (
                        <Section className="no-result-found">
                          <Image
                            src={ICONS['icon-ssr.png']}
                            className="no-result"
                          />
                          <p>No result found</p>
                        </Section>
                      )}
                    </Table>
                  </Section>
                  <Section className="content-footer">
                    <Section className="showing-item">
                      Showing{' '}
                      {listOnline.length === 0
                        ? '0'
                        : Math.min(
                            (resOnline.page - 1) * resOnline.limit + 1
                          )}{' '}
                      to{' '}
                      {Math.min(
                        resOnline.total_record,
                        resOnline.limit * resOnline.page
                      )}{' '}
                      of {resOnline.total_record} entries
                    </Section>

                    <Section className="paginate-wrapper">
                      <Paginate
                        activePage={activePage}
                        onChange={pageNumber =>
                          this.onPageChangeOnline(pageNumber)
                        }
                        itemsCountPerPage={resOnline.limit}
                        totalItemsCount={resOnline.total_record}
                        // pageRangeDisplayed={resOffline.total_page}
                      />

                      <Section className="moveto-wrapper">
                        <NumberFormat
                          label="Page"
                          isHorizontal
                          className="paginate-moveto"
                          defaultValue="1"
                          maxLength="4"
                          customInput={Input}
                          decimalSeparator={false}
                          allowNegative={false}
                          allowLeadingZeros={false}
                          onChange={e => {
                            if (this._isMounted) {
                              return this.setState({
                                searchPageOnline: parseInt(e.target.value),
                              })
                            }
                          }}
                          isAllowed={values => {
                            const { value, floatValue } = values
                            if (value == 0 && value !== '') {
                              return false
                            }
                            if (
                              typeof floatValue === 'undefined' ||
                              typeof value === 'undefined'
                            ) {
                              return true
                            }
                            if (value.charAt(0) === '0') {
                              if (value.charAt(1) && value.charAt(1) != '.') {
                                return false
                              }
                            }
                            if (this.props.maximum) {
                              return floatValue <= this.props.maximum
                            } else {
                              return true
                            }
                          }}
                        />
                        <Button
                          disabled={
                            parseInt(this.state.searchPageOnline) <=
                            parseInt(resOnline.total_page)
                              ? false
                              : true
                          }
                          onClick={() =>
                            this.onPageChangeOnline(this.state.searchPageOnline)
                          }
                        >
                          go
                        </Button>
                      </Section>
                    </Section>
                  </Section>
                </Tabber.TabPanel>
              </Tabber>
            </Section>
          </Section>

          {/* Create Template */}
          <Modal
            className="buyer template-manager theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'templateManager'
                })
                .map(obj => obj.isOpen)[0]
            }
          >
            <Formik
              enableReinitialize
              initialValues={{
                name: '',
                topic_offline_template: [],
                topicName: '',
              }}
              validationSchema={this.validateSchema}
              validateOnChange={false}
              validateOnBlur={false}
              validateOnMount={false}
              onSubmit={(values, formiksAction) => {
                this.submitCreateOfflineTemplates(values, formiksAction)
              }}
            >
              {formikProps => {
                const {
                  values,
                  handleChange,
                  errors,
                  submitForm,
                  setFieldValue,
                  setErrors,
                  resetForm,
                } = formikProps
                return (
                  <Form onSubmit={submitForm}>
                    <Modal.Header>Create New Template</Modal.Header>

                    <Modal.Body>
                      <FieldArray
                        name="topic_offline_template"
                        render={arrayDataHelpers => (
                          <React.Fragment>
                            <Section className="form-wrapper">
                              <Section
                                className={`form-group ${
                                  (errors.name || !this.state.templateValid) &&
                                  'is-error labelname'
                                }`}
                              >
                                <label>Template Name:</label>

                                <Section className="form-group-control">
                                  <Section className="form-group-inner-wrapper">
                                    <Input
                                      type="text"
                                      name="name"
                                      value={values.name || ''}
                                      onChange={handleChange('name')}
                                      placeholder="Template name"
                                    />
                                  </Section>

                                  <Section className="message">
                                    {errors.name
                                      ? errors.name
                                      : this.state.templateValidText}
                                  </Section>
                                </Section>
                              </Section>
                            </Section>

                            <Section className="table-header-freeze-wrapper">
                              <Table className="template-manager header-freeze">
                                <Table.TBODY>
                                  <Table.TR>
                                    <Table.TH className="number-order">
                                      NO.
                                    </Table.TH>

                                    <Table.TH className="topic">TOPIC</Table.TH>

                                    <Table.TH className="actions">
                                      ACTION
                                    </Table.TH>
                                  </Table.TR>
                                </Table.TBODY>
                              </Table>

                              <Table className="template-manager split-row-color data-table">
                                <Table.TBODY>
                                  {(values.topic_offline_template || []).map(
                                    (item, index) => (
                                      <Table.TR
                                        key={`formOffline-${index}-${item}`}
                                      >
                                        <Table.TD className="number-order">
                                          {index + 1}
                                        </Table.TD>

                                        <Table.TD
                                          className={
                                            errors &&
                                            errors.topic_offline_template &&
                                            errors.topic_offline_template[index]
                                              ? 'is-error topic'
                                              : 'topic'
                                          }
                                        >
                                          <Input
                                            type="text"
                                            name="name"
                                            component={Input}
                                            value={
                                              (values.topic_offline_template[
                                                index
                                              ] &&
                                                values.topic_offline_template[
                                                  index
                                                ].name) ||
                                              ''
                                            }
                                            onChange={event => {
                                              this.setInputArray(
                                                setFieldValue,
                                                event,
                                                index
                                              )
                                            }}
                                          />
                                          <Section className="message">
                                            {errors &&
                                              errors.topic_offline_template &&
                                              errors.topic_offline_template[
                                                index
                                              ] &&
                                              errors.topic_offline_template[
                                                index
                                              ].name}
                                          </Section>
                                        </Table.TD>

                                        <Table.TD className="actions">
                                          <Section>
                                            <Button
                                              className="link"
                                              type="button"
                                              onClick={() => {
                                                arrayDataHelpers.remove(index)
                                              }}
                                            >
                                              <Image
                                                className="delete-circle-icon"
                                                src={
                                                  ICONS[
                                                    'icon-delete-circle-red.svg'
                                                  ]
                                                }
                                                alt="delete circle"
                                              />
                                            </Button>
                                          </Section>
                                        </Table.TD>
                                      </Table.TR>
                                    )
                                  )}
                                </Table.TBODY>
                              </Table>
                            </Section>

                            <Section className="form-wrapper add-topic">
                              <Section
                                className={
                                  !this.state.topicValid
                                    ? 'is-error form-group'
                                    : 'form-group'
                                }
                              >
                                <Section className="form-group-control">
                                  <Section className="form-group-inner-wrapper">
                                    <Input
                                      type="text"
                                      name="topicName"
                                      value={values.topicName || ''}
                                      placeholder="Topic name"
                                      onChange={e =>
                                        this.setInputToppicName(
                                          setFieldValue,
                                          e
                                        )
                                      }
                                    />
                                    <Button
                                      className="add-topic"
                                      onClick={() => {
                                        this.addTopicName(
                                          arrayDataHelpers,
                                          values,
                                          setFieldValue
                                        )
                                      }}
                                    >
                                      Add
                                    </Button>
                                  </Section>

                                  {!this.state.topicValid ? (
                                    <Section className="message">
                                      {this.state.topicValidText}
                                    </Section>
                                  ) : null}
                                </Section>
                              </Section>
                            </Section>
                          </React.Fragment>
                        )}
                      />

                      {this.renderGrade()}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        className="theme-border-gray close"
                        onClick={() => {
                          this.onClose()
                          setErrors({})
                          formikProps.resetForm()
                          resetForm()
                          this.setState({
                            templateValid: true,
                            templateValidText: '',
                          })
                        }}
                      >
                        Cancel
                      </Button>

                      <Button
                        className="theme-green save"
                        onClick={() => submitForm()}
                      >
                        Save
                      </Button>
                    </Modal.Footer>
                  </Form>
                )
              }}
            </Formik>
          </Modal>

          {/* Template manager Modal */}
          {/* Edit Modal */}
          <Modal
            className="buyer template-manager theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'editScore'
                })
                .map(obj => obj.isOpen)[0]
            }
          >
            <Formik
              enableReinitialize
              initialValues={this.state.formDetail}
              validationSchema={this.validateSchema}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={(values, formiksAction) => {
                this.submitUpdateOfflineTemplates(values, formiksAction)
              }}
            >
              {formikProps => {
                const {
                  values,
                  handleChange,
                  errors,
                  submitForm,
                  setFieldValue,
                  setErrors,
                  resetForm,
                } = formikProps
                return (
                  <Form onSubmit={submitForm}>
                    <Modal.Header>Edit Template</Modal.Header>
                    <Modal.Body>
                      <FieldArray
                        name="topic_offline_template"
                        render={arrayHelpers => (
                          <React.Fragment>
                            <Section className="form-wrapper">
                              <Section
                                className={`form-group ${
                                  (errors.name || !this.state.templateValid) &&
                                  'is-error labelname'
                                }`}
                              >
                                <label>Template Name:</label>

                                <Section className="form-group-control">
                                  <Section className="form-group-inner-wrapper">
                                    <Input
                                      type="text"
                                      name="name"
                                      value={values.name || ''}
                                      onChange={handleChange('name')}
                                    />
                                  </Section>

                                  <Section className="message">
                                    {errors.name
                                      ? errors.name
                                      : this.state.templateValidText}
                                  </Section>
                                </Section>
                              </Section>
                            </Section>
                            <Section className="table-header-freeze-wrapper">
                              <Table className="template-manager header-freeze">
                                <Table.TBODY>
                                  <Table.TR>
                                    <Table.TH className="number-order">
                                      NO.
                                    </Table.TH>

                                    <Table.TH className="topic">TOPIC</Table.TH>

                                    <Table.TH className="actions">
                                      ACTION
                                    </Table.TH>
                                  </Table.TR>
                                </Table.TBODY>
                              </Table>

                              <Table className="template-manager split-row-color data-table">
                                <Table.TBODY>
                                  {(values.topic_offline_template || []).map(
                                    (item, index) => (
                                      <Table.TR key={`nameTopic-${index}`}>
                                        <Table.TD className="number-order">
                                          {index + 1}
                                        </Table.TD>

                                        <Table.TD
                                          className={
                                            errors &&
                                            errors.topic_offline_template &&
                                            errors.topic_offline_template[index]
                                              ? 'is-error topic'
                                              : 'topic'
                                          }
                                        >
                                          <Input
                                            name={`topic_offline_template.${index}.name`}
                                            value={item.name || ''}
                                            onChange={event => {
                                              this.setInputArray(
                                                setFieldValue,
                                                event,
                                                index
                                              )
                                            }}
                                          />
                                          <Section className="message">
                                            {errors &&
                                              errors.topic_offline_template &&
                                              errors.topic_offline_template[
                                                index
                                              ] &&
                                              errors.topic_offline_template[
                                                index
                                              ].name}
                                          </Section>
                                        </Table.TD>

                                        <Table.TD className="actions">
                                          <Section>
                                            <Button
                                              className="link"
                                              type="button"
                                              onClick={() => {
                                                arrayHelpers.remove(index)
                                              }}
                                            >
                                              <Image
                                                className="delete-circle-icon"
                                                src={
                                                  ICONS[
                                                    'icon-delete-circle-red.svg'
                                                  ]
                                                }
                                                alt="delete circle"
                                              />
                                            </Button>
                                          </Section>
                                        </Table.TD>
                                      </Table.TR>
                                    )
                                  )}
                                </Table.TBODY>
                              </Table>
                            </Section>

                            <Section className="form-wrapper add-topic">
                              <Section
                                className={
                                  !this.state.topicValid
                                    ? 'is-error form-group'
                                    : 'form-group'
                                }
                              >
                                <Section className="form-group-control">
                                  <Section className="form-group-inner-wrapper">
                                    <Input
                                      type="text"
                                      name="topicName"
                                      value={values.topicName || ''}
                                      onChange={e => {
                                        this.setInputToppicName(
                                          setFieldValue,
                                          e
                                        )
                                      }}
                                      placeholder="Topic name"
                                    />
                                    <Button
                                      className="add-topic"
                                      onClick={() => {
                                        this.addTopicName(
                                          arrayHelpers,
                                          values,
                                          setFieldValue
                                        )
                                      }}
                                    >
                                      Add
                                    </Button>
                                  </Section>
                                  {!this.state.topicValid ? (
                                    <Section className="message">
                                      {this.state.topicValidText}
                                    </Section>
                                  ) : null}
                                </Section>
                              </Section>
                            </Section>
                          </React.Fragment>
                        )}
                      />
                      {this.renderGrade()}
                    </Modal.Body>

                    <Modal.Footer>
                      <Button
                        className="theme-border-gray close"
                        onClick={() => {
                          this.onClickClose()
                          setFieldValue('topicName', '')
                          setErrors({})
                          resetForm()
                          this.setState({
                            templateValid: true,
                            templateValidText: '',
                          })
                        }}
                      >
                        Close
                      </Button>

                      <Button
                        className="theme-green save"
                        onClick={() => submitForm()}
                      >
                        Save
                      </Button>
                    </Modal.Footer>
                  </Form>
                )
              }}
            </Formik>
          </Modal>

          {/*Modal sent*/}
          <Modal
            id="send_id"
            className="theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'send'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth="575px"
          >
            <Modal.Header>Send</Modal.Header>

            <Modal.Body>
              <p className="default text-center">Are you sure to send?</p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="close_modal_history_id"
                className="theme-border-gray"
                onClick={() => this.onClickClose()}
              >
                Cancel
              </Button>

              <Button
                id="close_modal_history_id"
                className="theme-green"
                onClick={() => {
                  this.onClickClose()
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          {/*Modal Delete*/}
          <Modal
            id="delete_id"
            className="theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'delete'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth="575px"
          >
            <Modal.Header>Delete</Modal.Header>

            <Modal.Body>
              <p className="default text-center">
                Are you sure to delete? <br />
                {modals[0].FullName}
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="close_modal_history_id"
                className="theme-border-gray"
                onClick={() => this.onClickClose()}
              >
                Cancel
              </Button>

              <Button
                id="close_modal_history_id"
                className="theme-green"
                onClick={() => {
                  this.deleteList()
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          {/*Modal Delete online*/}
          <Modal
            id="delete_online_id"
            className="theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'deleteOnline'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth="575px"
          >
            <Modal.Header>Delete</Modal.Header>

            <Modal.Body>
              <p className="default text-center">Are you sure to delete ?</p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="close_modal_history_id"
                className="theme-border-gray"
                onClick={() => this.onClickClose()}
              >
                Cancel
              </Button>

              <Button
                id="close_modal_history_id"
                className="theme-green"
                onClick={() => {
                  this.deleteOnlineList()
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>
        </ComprehensiveAssessmentManagementStyled>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}
export const ComprehensiveAssessmentManagementContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ComprehensiveAssessmentManagement)
